import './aff_question.css';

function cuth2 (title) {
  if (title.length > 30) {
    let etoile = title.split('*').length-1
    let title_p1 = ''
    let title_p2 = ''
    if (title.includes('<svg ') || title.includes('<img ')){
      let title_p1 = title.split('<')[0]
      let title_p2 = title.replace(title_p1, '')
      if(title_p1.length > 30) {
       return title_p1.replaceAll('*', '⭐').slice(0,30)+'... ' + '⭐'.repeat(etoile)+ '' + title_p2
      }
      return title_p1.replaceAll('*', '⭐') + title_p2
    }
    return title.replaceAll('*', '').slice(0,30)+'... ' + '⭐'.repeat(etoile)
  }
  return title.replaceAll('*', '⭐')
}

function Reponse (rep) {
  if (Array.isArray(rep.rep[3])){
    return <div className={rep.rep[3].length==3 ? 'reponse qcm c3' : 'reponse qcm'}>
      {rep.rep[3].map((elt, k)=> 
        !(elt+'').includes('checkbox') ? 
          <label key={k}> 
            <input className="radio" type={rep.rep[3].includes('checkbox1') || rep.rep[3].includes('checkbox2') || rep.rep[3].includes('checkbox3') || rep.rep[3].includes('checkbox4') ? 'checkbox' : 'radio'} /> {<span dangerouslySetInnerHTML={{ __html:(elt+'').replaceAll('src="', 'src="https://maths-au-quotidien.fr/images/automaths/')}}></span>}
          </label>
        :''
      )}
    </div>
  } else {
    return <div className="reponse" dangerouslySetInnerHTML={{ __html:rep.rep[3]}}></div>
  }
}

export function Aff_question({question, key_tab, handleClick, tag, mode_classe=false, num_quest=''}) {
  
  let quest = question ? question[2].replaceAll('src="', 'src="https://maths-au-quotidien.fr/images/automaths/') : ''
  //let h2 = question[1].length >30 ? num_quest+' '+question[1].replaceAll('*', '⭐').slice(0,30) + '... ' + '⭐'.repeat(question[1].split('*').length-1): num_quest+' '+question[1].replaceAll('*', '⭐')
  
  return (
    question && 
    <div className="page">
      <div className="enonce">
        {(tag == 'Ajouter' && key_tab.includes('created')) && <div name="suppr_serie" className="suppr_serie" id={key_tab.split('ted')[1]} onClick={handleClick} style={{right:'10px',top:'5px'}}></div>}
        <h1 title={question[0]}>{question[0].length > 23 ? question[0].slice(0,23) + '...' : question[0] }</h1>
        <h2 dangerouslySetInnerHTML={{ __html:num_quest+' '+cuth2(question[1])}} title={question[1].replaceAll('*', '⭐')}></h2>
        <div dangerouslySetInnerHTML={{ __html:quest}} onClick={e=>e.target.classList.toggle('max')}></div>
      </div>

      <Reponse rep={question} />
      <br/>
      {tag ?  <span>
                <button className="btn" name={key_tab} onClick={handleClick}>{tag}</button>
                <br/>
              </span> : ''}
      {mode_classe && <>
              <div className="precedent" onClick={handleClick}></div>
              <div className="suivant" onClick={handleClick}></div>
            </>}
    </div>
  );
}
